import { useCallback, useEffect, useState } from "react";
import { loadStripe, Stripe } from "@stripe/stripe-js";

interface UseStripeOptions {
  publishableKey?: string;
  organization?: {
    stripe_config?: {
      publishable_key: string;
    };
  };
  event?: {
    stripe?: {
      publishable_key: string;
    };
  };
}

export const useStripe = (options: UseStripeOptions = {}) => {
  const [stripeObject, setStripeObject] = useState<Stripe | null>(null);
  const [loading, setLoading] = useState(false);

  const initializeStripe = useCallback(async () => {
    setLoading(true);
    try {
      let publishableKey: string | undefined;

      // Check for publishable key in different sources
      if (options.publishableKey) {
        publishableKey = options.publishableKey;
      } else if (options.organization?.stripe_config?.publishable_key) {
        publishableKey = options.organization.stripe_config.publishable_key;
      } else if (options.event?.stripe?.publishable_key) {
        publishableKey = options.event.stripe.publishable_key;
      }

      if (publishableKey) {
        const stripe = await loadStripe(publishableKey);
        setStripeObject(stripe);
      }
    } catch (error) {
      console.error("Failed to initialize Stripe:", error);
    } finally {
      setLoading(false);
    }
  }, [
    options.publishableKey,
    options.organization?.stripe_config?.publishable_key,
    options.event?.stripe?.publishable_key,
  ]);

  useEffect(() => {
    initializeStripe();
  }, [initializeStripe]);

  return {
    stripe: stripeObject,
    loading,
    refetch: initializeStripe,
  };
};
